import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "../../common/components/Button";

const FamilyAccountNotFoundDialog = ({ open, onLogout }) => {
  return (
    <Dialog className="popup" open={open} disableEscapeKeyDown aria-labelledby="family-account-not-found-title">
      <DialogContent>
        <DialogContentText id="family-account-not-found-title">Your account is no longer active. Please log in again.</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button label="LOGOUT" onClick={onLogout} className="confirm-cancel-button" />
      </DialogActions>
    </Dialog>
  );
};

export default FamilyAccountNotFoundDialog;
